module.exports = __webpack_public_path__ + "d4c0b303/img/cadBim.e369a02a.png";